import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getData1 } from "../../../Apis/ApiCalls";
import {
  API_ENDPOINT,
  GET_ALL_CATEGORIES,
  GET_SUB_CATEGORY,
} from "../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const MobileNavMenu = () => {
  const { t } = useTranslation();

  const [buyOpen, setBuyOpen] = useState(false);
  const [rentOpen, setRentOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getData1(`${API_ENDPOINT}${GET_ALL_CATEGORIES}`);
        if (response.success) {
          const categories = await Promise.all(
            response.detail.rows.map(async (category) => {
              const subCategories = await fetchSubCategories(category.id);
              return {
                ...category,
                subCategories,
              };
            })
          );
          setMenuItems(categories);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);
  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await getData1(
        `${API_ENDPOINT}${GET_SUB_CATEGORY}/${categoryId}`
      );
      return response.success ? response.detail.rows : [];
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      return [];
    }
  };
  const handleMouseEnter = (type) => {
    if (type === "buy") {
      setBuyOpen(true);
    } else if (type === "rent") {
      setRentOpen(true);
    }
  };
  const handleMouseLeave = (type) => {
    if (type === "buy") {
      setBuyOpen(false);
    } else if (type === "rent") {
      setRentOpen(false);
    }
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        {/* new menus */}
        <li>
          <Link to={process.env.PUBLIC_URL + "/"}>
            {/* <FontAwesomeIcon icon={faHome} />  */}
            {t("home")}
            {/* {sidebarMenu ? <span><FontAwesomeIcon icon={faAngleRight} /></span> : <FontAwesomeIcon icon={faAngleDown} />} */}
          </Link>
        </li>
        {/* <li>
            <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
              <FontAwesomeIcon icon={faShop} /> {t("shop")}
              {sidebarMenu ? <span><FontAwesomeIcon icon={faAngleRight} /></span> : <FontAwesomeIcon icon={faAngleDown} />}
            </Link>
          </li> */}

        <li
          className="menu-item-has-children"
          onMouseClick={() => handleMouseEnter("buy")}
        >
          <Link
            // to="/shops-store"
            state={{ mainValue: true, main: "Buy" }}
          >
            {t("Catalog")}
          </Link>
          <ul className="sub-menu">
            <li className="has-submenu">
              <Link
                to="/shops-store/all?mainValue=true&main=Buy"
                state={{ mainValue: true, main: "Buy" }}
                style={{ fontWeight: "bold" }}
              >
                ALL
              </Link>
            </li> 

            {menuItems.map((item, index) => (
              // <li key={index} className="has-submenu">
              <li key={index} className="menu-item-has-children">
                 <Link
                                    to={`/shop-store/${item.name.replace(
                                      /\s+/g,
                                      "-"
                                    )}?value=${
                                      item.id
                                    }&attribute=Category&main=Buy&mainValue=true`}
                                    style={{ textTransform: "uppercase" }}
                                  >
                                    {t(item.name)}
                                  </Link>

                {/* <ul className="submenu side">
                      {item.subCategories.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link to='/shop-grid-standard' state={{value: subItem.id,attribute:"SubCategory", main:"Buy", mainValue:true}}>
                            {t(subItem.name)}
                          </Link>
                        </li>
                      ))}
                    </ul> */}
              </li>
            ))}
          </ul>
        </li>

        <li>
          <Link to={process.env.PUBLIC_URL + "/about"}>
            {/* <FontAwesomeIcon icon={faPhone} /> */}
            {t("About Us")}
          </Link>
        </li>
        <li>
          <Link
            to={process.env.PUBLIC_URL + "/Blogs"}
            style={{ fontWeight: "bold" }}
          >
            {/* <FontAwesomeIcon icon={faPhone} /> */}
            {t("BLOGS")}
          </Link>
        </li>
        {/* <li>
          <Link to={process.env.PUBLIC_URL + "/Refund_policy"}>
            {t("Refund Policy")}
          </Link>
        </li> */}
        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>
            {/* <FontAwesomeIcon icon={faPhone} />  */}
            {t("Contact Us")}
          </Link>
        </li>
        {/* new menus end */}
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
